export default __webpack_public_path__ + "dist/media/Pencil-draw.6ed117a6.svg";